import styled from "styled-components";

export const PageContainer = styled.div`
  width: 100%;
  min-height: 100%;
  background: #f8f9fa;
  padding: 100px clamp(24px, 9.8vw, 141px) 60px;
`;

export const PageTitle = styled.h1`
  color: #080d1a;
  font-size: 32px;
  font-family: 'Work Sans', sans-serif;
  font-weight: 500;
  line-height: 40px;
  margin: 0 0 80px;
`;

export const SectionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Section = styled.div`
  display: flex;
  gap: clamp(24px, 9.4vw, 135px);
  align-items: flex-start;
  flex-wrap: wrap;
`;

export const SectionLabel = styled.div`
  width: min(335px, 100%);
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SectionTitle = styled.h2`
  color: #080d1a;
  font-size: 20px;
  font-family: 'Work Sans', sans-serif;
  font-weight: 600;
  line-height: 24px;
  margin: 0;
`;

export const SectionDescription = styled.p`
  color: #676a70;
  font-size: 14px;
  font-family: 'Work Sans', sans-serif;
  font-weight: 400;
  line-height: 18px;
  margin: 0;
`;

export const AccordionList = styled.div`
  flex: 1 1 300px;
  min-width: 0;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const AccordionItem = styled.div`
  background: white;
`;

export const AccordionHeader = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 24px;
  background: transparent;
  border: none;
  cursor: pointer;
  text-align: left;

  &:hover {
    background: #f8f9fa;
  }
`;

export const AccordionItemTitle = styled.span`
  flex: 1;
  color: #080d1a;
  font-size: 18px;
  font-family: 'Work Sans', sans-serif;
  font-weight: 500;
  line-height: 24px;
`;

export const AccordionBody = styled.div`
  padding: 0 24px 24px;
  color: #676a70;
  font-size: 14px;
  font-family: 'Work Sans', sans-serif;
  font-weight: 400;
  line-height: 18px;
`;
